import React, { Component } from 'react'

/*
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta http-equiv="X-UA-Compatible" content="ie=edge">
<title>Booking charts</title>
<link href="jumbotron.css" rel="stylesheet">
<link href="https://cdn.datatables.net/1.10.22/css/dataTables.bootstrap4.min.css" rel="stylesheet">
<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous">
*/

export default class VectorLayersExample extends Component {
  render() {
    return (
        <div className="layout text">
            <h1>Bienvenue sur l'analyse des réservations sur Booking</h1>
            Veuillez choisir une zone prédéfinie afin d'afficher les statistiques hotelières.
        </div>
    )}
}
